var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg_box" }, [
    _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "header" }, [_vm._v("数据资产平台")]),
      _c("div", { staticClass: "text" }, [
        _vm._v(
          "当合同签署完成后，这份具有法律效力的文件不再仅仅是传统意义上的合约记录，在这里，合同成为了宝贵的数据资产，开启了价值释放的全新旅程。"
        )
      ]),
      _c("p", { staticClass: "title" }, [_vm._v("数据智仓")]),
      _c("div", { staticClass: "list_ul" }, [
        _vm._v(
          "\n      支持多种数据源类型，自动构建高性能数据仓库，支持大规模数据存储和快速查询，多层级数据资产分类管理，可自由创建多级分类。\n    "
        )
      ]),
      _c("p", { staticClass: "title" }, [_vm._v("数据治理")]),
      _c("div", { staticClass: "list_ul" }, [
        _vm._v(
          "\n      数据质量智能评估，对数据清洗转换，利用算法模型、逻辑推理、自然语言处理等对数据进行标准化处理，借助深度学习算法智能分类数据。\n    "
        )
      ]),
      _c("p", { staticClass: "title" }, [_vm._v("数据分析")]),
      _c("div", { staticClass: "list_ul" }, [
        _vm._v(
          "\n      提供丰富的数据分析算法和模型，基于海量数据训练基础，发现数据中的潜在模式和趋势，为决策提供支持。\n    "
        )
      ]),
      _c("p", { staticClass: "title" }, [_vm._v("资产入表")]),
      _c("div", { staticClass: "list_ul" }, [
        _vm._v(
          "\n      与专业数据资产盘点团队合作，对企业数据资产进行全方位的梳理评估，严格遵循《企业会计准则》中关于无形资产确认和计量的相关规定，制定详细的数据资产入表流程。\n    "
        )
      ]),
      _c("p", { staticClass: "title" }, [_vm._v("资产确权")]),
      _c("div", { staticClass: "list_ul" }, [
        _vm._v(
          "\n      利用区块链技术的不可篡改性和分布式特性，为数据资产提供唯一且可追溯的标识，确保数据资产的权属清晰、交易透明。\n    "
        )
      ]),
      _c("div", { staticClass: "positon_box" }, [
        !_vm.isInDingTalk && _vm.showChangeAccount
          ? _c(
              "div",
              { staticClass: "change-account-sty" },
              [
                _c("change-account-com", {
                  attrs: {
                    showImg: false,
                    justSwitching: true,
                    hideSelf: true,
                    users: _vm.consoleUsers,
                    lineHeight: 59
                  },
                  on: { showExpandIcon: function() {}, justCall: _vm.pointCall }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "div",
        { staticClass: "footer_box" },
        [
          _c(
            "div",
            {
              staticClass: "submit_btn",
              attrs: { tabindex: "0", hidefocus: true },
              on: {
                click: _vm.gotoJunziqianPrmLogin,
                blur: _vm.closeChangeAccountFn
              }
            },
            [_vm._v("立即使用\n      ")]
          ),
          _c(
            "el-popover",
            { attrs: { placement: "top", width: "100", trigger: "click" } },
            [
              _c("div", { staticClass: "browser_list" }, [
                _c(
                  "div",
                  {
                    staticClass: "list_1",
                    on: {
                      click: function($event) {
                        return _vm.browserDowload(
                          "https://www.google.cn/chrome/"
                        )
                      }
                    }
                  },
                  [_vm._v("谷歌浏览器")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "list_1",
                    on: {
                      click: function($event) {
                        return _vm.browserDowload("https://www.firefox.com.cn/")
                      }
                    }
                  },
                  [_vm._v("火狐浏览器")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "list_1",
                    on: {
                      click: function($event) {
                        return _vm.browserDowload("https://browser.360.cn/ee/")
                      }
                    }
                  },
                  [_vm._v("360极速浏览器")]
                )
              ]),
              _c(
                "span",
                {
                  staticClass: "browser_text",
                  attrs: { slot: "reference" },
                  slot: "reference"
                },
                [_vm._v("推荐下载新版浏览器")]
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3631730", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3631730","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/introducePage/index.vue
// module id = V1fo
// module chunks = 148